const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const readString = (record: Record<string, unknown>, ...keys: string[]): string | undefined => {
  const value = keys.map((key) => record[key]).find((item) => typeof item === 'string')
  return typeof value === 'string' ? value : undefined
}

export const extractAccessToken = (payload: unknown): string | undefined => {
  const root = isRecord(payload) ? payload : {}
  const nestedResult = root.result ?? root.Result
  const result = isRecord(nestedResult) ? nestedResult : root
  return readString(result, 'accessToken', 'token') ?? readString(root, 'accessToken', 'token')
}
